<template>
  <v-form ref="usernametextfield" @submit="submit" onSubmit="return false;">
    <StoryCityTextInput
      v-model="username"
      outlined
      label="Username"
      prepend-icon="mdi-at"
      :rules="rules"
      :loading="$apollo.queries.usernameExists.loading"
      :error-messages="usernameErrors"
      @update:error="error = $event"
      :valid="
        (currentUsername != '' && username == currentUsername) ||
        (!usernameExists && usernameErrors.length === 0 && !error)
      "
      :showValid="username.length > 0 && !preDebounce"
    />
  </v-form>
</template>
<script>
import debounce from "@/helpers/debounce";
import { USER_EXISTS } from "@/graphql/UserQueries";
import StoryCityTextInput from "@/components/Reusable/StoryCityTextInput";
import {
   MAX_USERNAME_CHARS,
   MIN_USERNAME_CHARS,
} from "@/const"
export default {
  components: {
    StoryCityTextInput,
  },
  data() {
    return {
      username: this.value,
      usernameErrors: [],
      queryAllowed: false,
      queryUsername: "",
      preDebounce: false,
      error: false,
    };
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    currentUsername: {
      type: String,
      default: "",
    },
  },
  methods: {
    debouncedUsernameChange: debounce(function (newValue) {
      this.preDebounce = false
      if (
        this.username.length >= MIN_USERNAME_CHARS &&
        this.username.length <= MAX_USERNAME_CHARS &&
        this.username.toLowerCase() != this.currentUsername.toLowerCase()
      ) {
        this.queryAllowed = true;
        this.queryUsername = newValue;
      } else {
        this.queryAllowed = false;
      }
    }, 500),
    submit() {
      this.$emit('submit');
    }
  },
  apollo: {
    usernameExists: {
      query: USER_EXISTS,
      fetchPolicy: "network-only",
      variables() {
        return {
          username: this.queryUsername,
        };
      },
      update(data) {
        this.$refs.usernametextfield.validate();
        return data.existsUser != null;
      },
      skip() {
        return !this.queryAllowed;
      },
    },
  },
  watch: {
    valid(newValue) {
      this.$emit("valid", newValue);
    },
    usernameErrors(newValue) {
      if (newValue.length > 0) {
        this.valid = false;
      }
    },
    username(newValue) {
      this.preDebounce = true;
      this.$emit("input", newValue);
      this.debouncedUsernameChange(newValue)
    },
    usernameExists: function () {
      this.$refs.usernametextfield.validate();
    },
  },
  computed: {
    valid() {
      return (
        this.preDebounce == false &&
        this.usernameExists == false &&
        this.usernameErrors.length == 0 &&
        this.username.length >= MIN_USERNAME_CHARS &&
        this.username.length <= MAX_USERNAME_CHARS
      );
    },
    loading() {
      return this.$apollo.queries.usernameExists.loading;
    },
    rules() {
      if (this.username.length > 0) {
        return [
          () => !!this.username || this.$t("forms.thisFieldIsRequired"),
          // username contains no spaces or special characters
          () =>
            !this.usernameExists ||
            this.preDebounce ||
            this.loading ||
            this.$t("register.usernameInUse"),
          () =>
            /^[a-zA-Z0-9_]+$/.test(this.username) ||
            this.$t("register.usernameContainsNoSpacesOrSpecialCharacters"),
          () =>
            this.username.length >= MIN_USERNAME_CHARS ||
            this.$t("register.usernameSize"),
          () =>
            this.username.length <= MAX_USERNAME_CHARS ||
            this.$t("register.usernameSize"),
        ];
      }
      return [];
    },
  },
};
</script>